import Cookies from "js-cookie";
import React from "react";
import { FileField } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { uploadFile } from "~/pages/CatalogApplications/catalogApi";

const API_URL = process.env.REACT_APP_CANDIDATE_API_URL;

export function FileAuditUploader({
  candidateId,
  onUploaded,
  isCandidateFile,
}) {
  const { t } = useTranslation();
  const [uploading, setUploading] = React.useState(false);

  const mutation = useMutation({
    mutationFn: async ({ file }: { file: File }) => {
      setUploading(true);

      try {
        const { fileId } = await uploadFile({ file, forField: "auditFileId" });

        const token = Cookies.get("token");
        if (!token) throw new Error("No token found");

        const res = await fetch(`${API_URL}/candidate/audit-file`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            auditFileId: fileId,
            candidateId,
          }),
        });

        if (!res.ok) throw new Error("Ошибка при отправке auditFileId");

        return true;
      } finally {
        setUploading(false);
      }
    },
    onSuccess: () => {
      onUploaded?.();
    },
    onError: (error) => {
      console.error("Ошибка при загрузке файла аудита:", error);

      alert(`${t("common.data_uploaded_error")}: ${error}`);
    },
  });

  // Режим «пикер»: значение FileField всегда null, после загрузки
  // CatalogInfa инвалидирует getCatalogData и перерисовывает блок аудита.
  return (
    <FileField
      value={null}
      uploadLabel={
        isCandidateFile
          ? t("catalog.replace_audit_file")
          : t("catalog.upload_audit_file")
      }
      hint={t("catalog.audit_file_size_hint")}
      accept={["application/pdf", ".pdf"]}
      maxSizeMb={15}
      loading={uploading}
      onUpload={(file) => mutation.mutate({ file })}
    />
  );
}
